// extracted by mini-css-extract-plugin
export var dividerContainer = "_5r-0";
export var line = "_5r-1";